import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./login.css";
import logo from "../assets/logo.png";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = () => {
    setError("");

    if (!email || !password) {
      setError("Please enter email and password");
      return;
    }

    const admins = JSON.parse(localStorage.getItem("admins")) || [];
    const admin = admins.find(
      a => a.email === email && a.password === password
    );

    if (!admin) {
      setError("Invalid email or password");
      return;
    }

    localStorage.setItem("loggedInAdmin", admin.email);
    localStorage.setItem("adminName", admin.username);

    navigate("/dashboard");
  };

  return (
    <div className="login-page">
      <div className="bg-overlay"></div>

      <div className="login-card">
        <img src={logo} className="logo" alt="NX Optics" />
        <h3>Welcome Back</h3>
        <small>Sign in to continue</small>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />

        <button onClick={handleLogin}>Log In</button>

        {error && <p className="error">{error}</p>}

        <p className="auth-footer">
          Don’t have an account? <Link to="/register">Register</Link>
        </p>
      </div>
    </div>
  );
}
